import {FC} from 'react'
import CheckInAutoAuto from '../components/CheckInAutoAuto'

const HeaderCheckInAutoAutoPanel: FC = () => {
  return (
    <>
      <div className=''>
        <CheckInAutoAuto />
      </div>
    </>
  )
}

export {HeaderCheckInAutoAutoPanel}
